import api from '@/api/api';
import {toast} from '@/components/utils/ui_v4/alerts/toast/toast';
import {computed, onMounted, ref, watch} from 'vue';

export default function useSeguidoresDialog(props, emit) {
  const activeTab = ref(0);
  const searchQuery = ref('');
  const selectedSeguidores = ref([]);
  const favoritos = ref([]);
  const selectAll = ref(false);
  const isLoadingFavoritos = ref(false);

  const loadFavoritos = async () => {
    isLoadingFavoritos.value = true;
    try {
      const {data} = await api.get('/cotacao/criar_cotacao_listar_seguidores_cotacao_favoritos');
      if (data && Array.isArray(data.seguidores_favoritos)) {
        favoritos.value = data.seguidores_favoritos.map(f => f.user_id);
      }
    } catch (error) {
      toast.error('Erro ao carregar favoritos!');
      
    } finally {
      isLoadingFavoritos.value = false;
    }
  };

  onMounted(async () => {
    await loadFavoritos();
  });

  watch(() => props.visible, async (newVal) => {
    if (newVal) {
      selectedSeguidores.value = [...props.seguidoresSelecionados];
      await loadFavoritos();
      updateSelectAll();
    }
  });

  const filteredSeguidores = computed(() => {
    let lista = props.seguidores;

    if (activeTab.value === 0) {
      lista = lista.filter(s => favoritos.value.includes(s.id));
    }

    if (searchQuery.value) {
      const query = searchQuery.value.toLowerCase();
      lista = lista.filter(s =>
        s.name.toLowerCase().includes(query) ||
        s.id.toString().includes(query)
      );
    }

    return lista;
  });

  const selectedCount = computed(() => selectedSeguidores.value.length);

  const isFavorite = (id) => {
    return favoritos.value.includes(id);
  };

  const toggleFavorite = async (id) => {
    const index = favoritos.value.indexOf(id);

    if (index > -1) {
      favoritos.value.splice(index, 1);

      try {
        await api.delete('/cotacao/criar_cotacao_remover_seguidor_favorito', {
          data: {user_id: [id]}
        });
      } catch (error) {
        
        toast.error('Não foi possível remover o favorito');
        favoritos.value.push(id);
      }
    } else {
      favoritos.value.push(id);

      try {
        await api.post('/cotacao/criar_cotacao_adicionar_seguidor_favorito', {
          user_id: [id]
        });
      } catch (error) {
        
        toast.error('Não foi possível adicionar o favorito');
        const idx = favoritos.value.indexOf(id);
        if (idx > -1) favoritos.value.splice(idx, 1);
      }
    }
  };

  const updateSelectAll = () => {
    const visibleIds = filteredSeguidores.value.map(s => s.id);
    selectAll.value = visibleIds.length > 0 && visibleIds.every(id => selectedSeguidores.value.includes(id));
  };

  const toggleSelectAll = () => {
    const visibleIds = filteredSeguidores.value.map(s => s.id);

    if (selectAll.value) {
      visibleIds.forEach(id => {
        if (!selectedSeguidores.value.includes(id)) {
          selectedSeguidores.value.push(id);
        }
      });
    } else {
      selectedSeguidores.value = selectedSeguidores.value.filter(id => !visibleIds.includes(id));
    }
  };

  watch(selectedSeguidores, () => {
    updateSelectAll();
  }, {deep: true});

  watch(filteredSeguidores, () => {
    updateSelectAll();
  });

  const handleSave = () => {
    emit('save', selectedSeguidores.value);
    props.handleClose();
  };

  return {
    activeTab,
    searchQuery,
    selectedSeguidores,
    favoritos,
    selectAll,
    isLoadingFavoritos,
    filteredSeguidores,
    selectedCount,
    isFavorite,
    toggleFavorite,
    toggleSelectAll,
    handleSave,
  };
}
